/* eslint-disable import/no-anonymous-default-export */
import siteConfig from "../siteConfig";

export default {
  path: "/cancellations",
  shortTitle: "Cancellations",
  title: "Order changes and cancellation",
  category: "Orders and delivery",
  summary: "What can be changed before acceptance or fulfilment and what happens when an order cannot proceed.",
  updated: "26 October 2026",
  sections: [
    {
      heading: "Customer requests",
      body: [
        "Email customer care immediately with the order number and the exact item, quantity or address change requested. A message is a request, not confirmation. Changes are most feasible before stock allocation, workshop confirmation, packing or delivery hand-off; the code supplies no operational cut-off time that would justify a more precise promise.",
      ],
    },
    {
      heading: "Payment-session and address mistakes",
      body: [
        "Closing or cancelling the hosted payment page normally leaves the cart in the browser and does not prove a charge. If payment appears on an account but no verified order message arrives, send the payment reference and do not repeat checkout until customer care reviews it. For a wrong address, provide both the entered and corrected address; rerouting is not guaranteed after hand-off.",
      ],
    },
    {
      heading: "Merchant cancellation",
      body: [
        `Before accepting a purchase request, ${siteConfig.brandName} may stop it for exhausted stock, an unverifiable charge, an obvious catalog error, an unserviceable destination, credible fraud signals, an unconfirmable workshop place, or unsafe or unlawful fulfilment. When security and law permit, customer care will identify which of those practical barriers prevented acceptance.`,
      ],
    },
    {
      heading: "Money and rights",
      body: [
        "Where cancellation follows a captured charge, the affected sum must travel back by the route used to pay. Its appearance on an account can depend on the provider or bank. This cancellation process does not narrow remedies arising from an incorrectly retained charge, absent delivery, defective goods or any protection that law makes non-waivable.",
      ],
    },
  ],
};
